<template>
  <div class="col-list">
    <div
      v-for="(item,index) in houseList"
      :key="index"
      class="col-property"
    >
      <div>
        <svg
          v-if="item.collectionID"
          class="icon col-icon"
          aria-hidden="true"
          @click="deleteCollection(item.collectionID,index,'new')"
        >
          <use xlink:href="#icon-myFavourites1" />
        </svg>
        <svg
          v-else
          class="icon col-icon del-icon"
          aria-hidden="true"
          @click="addCollection(index,item.newEstate.estateId,'new')"
        >
          <use xlink:href="#icon-shoucang1" />
        </svg>
      </div>
      <van-cell
        v-if="item.newEstate"
        @click="goUrl(item)"
      >
        <van-card>
          <div
            slot="title"
            class="col-title col-adress"
          >
            <span>{{ item.newEstate.estateName }}</span>
          </div>
          <!-- 图片部分 -->
          <div
            slot="thumb"
            class="col-card__thumb"
          >
            <img
              v-lazy="pub.imgResize(item.newEstate.defaultImage,'company')"
              class="img-hse"
              onerror="errorImg(this)"
            >
            <div v-if="item.newEstate.isVideo">
              <svg
                class="icon reviewed"
                aria-hidden="true"
              >
                <use xlink:href="#icon-yingpian" />
              </svg>
            </div>
          </div>
          <div
            v-if="item.newEstate.estateNameEn"
            slot="desc"
            class="col-desc col-adress"
          >
            <span>{{ item.newEstate.estateNameEn }}</span>
          </div>
          <!-- 置顶标签 -->
          <div
            v-if="item.newEstate.newEstateLabel===1 || item.newEstate.newEstateLabel===2"
            slot="tag"
            class="col-tag"
          >
            {{ item.newEstate.newEstateLabelWithCulture }}
          </div>
          <!-- 地址 -->
          <div
            slot="tags"
            class="col-adress"
          >
            <img
              src="../assets/ditu.png"
              alt=""
              class="xf-img"
            >
            <span class="card-tags">
              {{ item.newEstate.areas?item.newEstate.areas[0].areaNameWithCulture:'' }}&nbsp;
              {{ item.newEstate.detailAddressWithCulture }}</span>
          </div>
          <!-- 价单 面积 -->
          <div
            slot="price"
            class="bh-price"
          >
            <p
              v-if="item.newEstate.minSalePrice && item.newEstate.maxSalePrice"
              class="card-price col-adress"
            >
              <span v-if="item.newEstate.minSalePrice === item.newEstate.maxSalePrice">{{ tool.getPrice(item.newEstate.minSalePrice,lang.type) }}</span>
              <span v-else>{{ tool.getPrice(item.newEstate.minSalePrice,lang.type) }}-{{ tool.getPrice(item.newEstate.maxSalePrice,lang.type) }}</span>
            </p>
            <p
              v-if="item.newEstate.minSaleableArea && item.newEstate.maxSaleableArea"
              class="new-area col-adress"
            >
              <span v-if="item.newEstate.minSaleableArea === item.newEstate.maxSaleableArea">{{ item.newEstate.minSaleableArea }}{{ lang.chi }}</span>
              <span v-else>{{ item.newEstate.minSaleableArea+'~'+item.newEstate.maxSaleableArea }}{{ lang.chi }}</span>
            </p>
            <p class="col-price">
              <span v-if="item.newEstate.mainDeveloperWithCulture">{{ item.newEstate.mainDeveloperWithCulture }}</span>
              <span v-if="item.newEstate.intakeYear">{{ lang.type === 'en-us' ? 'Yr.' : '' }}{{ item.newEstate.intakeYear }}{{ lang.type === 'en-us' ? '' : '年' }}</span>
              <span v-if="item.newEstate.attachmentPriceCount">{{ item.newEstate.attachmentPriceCount }}{{ (item.newEstate.attachmentPriceCount === 1 && lang.type==='en-us') ? 'Price List' : lang.isnewPrice }}</span>
            </p>
            <!-- <p class="col-price col-adress">
              <span v-if="item.newEstate.priceListNumber">{{item.newEstate.priceListNumber}}{{item.newEstate.priceListNumber===1 && lang.type==='en-us'?' Price List':lang.isnewPrice}}</span>
              <span v-else-if="item.newEstate.priceListType !== 1">{{item.newEstate.priceListTypeWithCulture}}</span>
            </p> -->
          </div>
        </van-card>
      </van-cell>
    </div>
  </div>
</template>

<script>
import pub from "../../common/public";
import lang from "../../common/language/history";
import tool from "../../common/js/tools.js"
const _conf = require('../../common/js/_conf');

export default {
  props: {
    houseList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    relatedList: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  data () {
    return {
      tool,
      lang,
      userData: {},
    };
  },
  created () {
    this.lang.type = this.pub.getLang();
    this.loadCollectAll(1, 'newestate')
    this.fetchUserInfo();
  },
  methods: {
    fetchUserInfo() {
      this.pub.getUserInfo().then(res => {
        this.userData = res;
      }).catch();
    },
        // 获取收藏屋苑
    loadCollectAll(index, type) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
          sourceType: type,
          pageCount: 100,
          pageIndex: index,
          isShowSourceInfo: true,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.ahou = false
            for (let i = 0; i < res.data.result.data.length; i++) {
              for (let z = 0; z < this.houseList.length; z++) {
                if (this.houseList[z]) {
                  if (this.houseList[z].newEstate.estateId == res.data.result.data[i].sourceID) {
                    this.$set(this.houseList[z], 'collectionID', res.data.result.data[i].collectionID);
                    this.ahou = true
                  }
                  if(!this.ahou){
                    this.$set(this.houseList[z], 'collectionID', '');
                  }
                }
              }
            }
            if (res.data.result.count > index * 100) {
              this.loadCollectAll(index + 1);
            }
          }
        });
    },
    goUrl (item) {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com':_conf.env_type == 3 ?'https://www.house730.com':'https://uat.house730.com.cn'
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/'
      location.href = `${base}/${type}new-property-${item.newEstate.estateId}/`;
      if(window.dataLayer && this.relatedList != 'history') {
        window.dataLayer.push({
          "event": "listingClick",
          "source": "SSRP-Bookmark",
          "target": "",
          "user":  {
            "language":  `${window._language}`,
            "id":  `${this.userData.userID}`,
          },
          "listing": {
            "id": item.newEstate.estateId,
            "region": item.newEstate.regionNameWithCulture || '',
            "district": item.newEstate.gscopeNameWithCulture || '',
            "building": item.newEstate.estateNameWithCulture || '',
            "productType": item.newEstate.saleStatusWithCulture || '',
            "channel": 'new',
            "propertyType": '',
            "agencyId": item.accountID ? 'A' + item.accountID : 'U' + item.userID,
          }
        })
      }
    },
    addCollection(index,estateId,type){
      this.$emit('newCollection',index,estateId,type)
    },
    deleteCollection(id,index,type){
      this.$emit('cancelCollection',id,index,type);
    }
  }
};
</script>
<style scoped>
.van-card__price{
  width:100%;
}
.col-list {
  margin-left: 15px;
  box-sizing: border-box;
}
.col-property{
  position:relative;
  border-bottom:1px solid #ebedf0;
}
.van-cell {
  padding: 15px 15px 6px 0;
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
}
.col-title {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}
.col-desc {
  font-size: 11px;
  color: #999999;
  line-height: 13px;
}
.xf-img{
  width:18px;
  height:18px;
  vertical-align: -4px;
  margin-right: 3px;
}
.card-tags{
  font-size:12px;
  color: #4D73BF;
  line-height: 24px;
}
.col-adress {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/* 图片部分 */
.van-card__thumb,
.col-card__thumb {
  width: 100px;
  height: 75px;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  text-align: center;
  background: url('//static.house730.com/m/images/house-bg.png');
  background-size: cover;
}
.van-card__thumb {
  margin-right: 16px;
}
.van-card__thumb img {
  width: 100px;
  height:75px;
  /* max-height: initial; */
}
.reviewed {
  font-size: 22px;
  position: absolute;
  left: 2px;
  bottom: 2px;
}
.col-icon {
  position: absolute;
  top:15px;
  right: 15px;
  font-size:20px;
  z-index:5;
}
.del-icon{
  font-size:24px;
}
.saled {
  font-size: 17px;
  color: #ffffff;
  opacity: 0.55;
  background: #292630;
  width: 120px;
  height: 90px;
  line-height: 90px;
  position: absolute;
  left: 0;
  top: 0;
}
/* 分类标签部分 */
.van-card {
  padding: 0 20px 0 0;
  background-color: #fff;
}
.van-ellipsis {
  overflow: inherit;
}
.van-card__content {
  text-align: left;
  height: auto;
}
.van-card__tag {
  top: 0;
}
.col-tag{
  color: #fff;
  background-image: linear-gradient(
    90deg,
    #ff3f4e 0%,
    #ff676d 100%
  );
  font-size: 10px;
  padding:0 2px;
  height: 15px;
  line-height:15px;
  text-align: center;
  margin:4px;
}
/* 价格部分 */
/* .new-price{
    width:100%;
}
.new-price p{
  height:40px;
  line-height:40px;
} */
.col-price {
  font-size: 14px;
  color: #333333;
}
.col-price span{
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 233px;
  vertical-align: middle;
  height: 18px;
  background: #DFE9FF;
  font-weight: 400;
  font-size: 12px;
  color: #536EA6;
  letter-spacing: 0;
  padding: 0px 4px;
  margin-bottom: 4px;
  margin-right: 4px;
}
.card-price {
  font-size: 13px;
  color: #ED1818;
  font-weight: 700;
}
.new-area{
  font-size: 11px;
  color: #999999;
}
/* .new-price .none-price{
  text-align:left;
  font-size:12px;
  color:#999999;
} */
</style>
